import { takeLatest, call, put } from 'redux-saga/effects';
import { DELETE_BANNERS_START, DELETE_BANNERS_ERROR, DELETE_BANNERS_SUCCESS, GET_BANNERS_START } from '../../types';

import apiCall from '../../../api/apiGet';

export function* del({ payload }) {
  try {
    const url = `/banners/delete/${payload.id}`;
    const method = 'DELETE';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: DELETE_BANNERS_SUCCESS, results: results.data });
    
  } catch (error) {
    console.log(error)
    yield put({ type: DELETE_BANNERS_ERROR, error });
  } finally {
    yield put({ type: GET_BANNERS_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* delete_banners() {
  yield takeLatest(DELETE_BANNERS_START, del);
}
